import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import MeditationUsersTable from './MeditationUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyMeditationUsers } from './companyMeditationApi';

/**
 * Company Meditation Sounds → Employees/Members list.
 * Every user of the current population appears (never-listened ones with
 * dashes, sorted last); a row opens their meditation profile.
 */
const CMeditationUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyMeditationUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Meditation Sounds — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and their meditation practice. Open a user to
        see their full meditation profile.
      </p>

      <MeditationUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/meditation/user?userId=${rowData?._id}`)}
        tableName="company_meditation_users"
      />
    </div>
  );
};

export default CMeditationUsers;
